import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App'
import store from './store'
import router from './router'
import keycloak from './plugins/keycloak'
import './assets/css/main.css'
import moment from "moment"

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueResource)

Vue.component('v-modal', () => import(/* webpackChunkName: "Default" */ './components/default/v-modal'))
Vue.component('v-date', () => import(/* webpackChunkName: "Default" */ './components/default/v-date'))
Vue.component('v-edit-field', () => import(/* webpackChunkName: "Default" */ './components/default/v-edit-field'))
Vue.component('v-input', () => import(/* webpackChunkName: "Default" */ './components/default/v-input'))
Vue.component('v-bool', () => import(/* webpackChunkName: "Default" */ './components/default/v-bool'))
Vue.component('v-pagination', () => import(/* webpackChunkName: "Default" */ './components/default/v-pagination'))
Vue.component('v-search', () => import(/* webpackChunkName: "Default" */ './components/default/v-search'))
Vue.component('v-toast',  () => import(/* webpackChunkName: "Default" */ './components/default/v-toast'))
Vue.component('v-code',  () => import(/* webpackChunkName: "Default" */ './components/default/v-code'))
Vue.component('v-loading',  () => import(/* webpackChunkName: "Default" */ './components/default/v-loading'))
Vue.component('v-select',  () => import(/* webpackChunkName: "Default" */ './components/default/v-select'))
Vue.component('v-table',  () => import(/* webpackChunkName: "Default" */ './components/default/v-table'))
Vue.component('v-block', () => import(/* webpackChunkName: "Default" */ './components/Block'))

Vue.config.productionTip = false

Vue.http.options.root = 'https://ftth.iliad.fr/api'
const CurrentVersion = '1.0.1'

function storeKeycloakUser() {
  var parsed = keycloak.tokenParsed
  var roles = (parsed.killi_user && parsed.killi_user.profils)
    ? parsed.killi_user.profils.map(function(p) { return p.name })
    : []

  localStorage.setItem('user', JSON.stringify({
    token: keycloak.token,
    id: parsed.killi_user_id,
    roles: roles,
    fn: parsed.name,
    issuer: parsed.preferred_username
  }))
}

keycloak.onTokenExpired = function () {
  keycloak.updateToken(70).then(function (refreshed) {
    if (!refreshed || !keycloak.token) return
    storeKeycloakUser()
  }).catch(function () {
    keycloak.login({ redirectUri: location.origin + '/' })
  })
}

keycloak.onAuthError = function () {
  keycloak.login({ redirectUri: location.origin + '/' })
}

Vue.http.interceptors.push((request, next) => {
  if (keycloak.token) {
    request.headers.set('Authorization', 'Bearer ' + keycloak.token)
  }
  next()
})

import { mapActions, mapGetters } from "vuex";
import theme from "./plugins/theme";

Vue.mixin({
  computed: {
    ...mapGetters('user', ['current'])
  },
  methods: {
    ...mapActions('toast', { addToast : 'add' }),
    ...mapActions('user', ['setCurrentUser', 'getCurrentUser']),
    getCurrentVersion () {
      return CurrentVersion
    },
    isGranted (rank_list) {
      if (!keycloak.tokenParsed) return false
      var roles = (keycloak.tokenParsed.killi_user && keycloak.tokenParsed.killi_user.profils)
        ? keycloak.tokenParsed.killi_user.profils.map(function(p) { return p.name })
        : []
      for (var rank in rank_list) {
        for (var role in roles) {
          if (roles[role] === rank_list[rank]) return true
        }
      }
      return false
    },
    toast (type, message) {
      this.addToast({ type: type, message: message })
    },
    dateFormat (value) {
      if(value === null) return "Jamais"
      let date = moment(value).format('DD/MM/YYYY')
      if(date === "01/01/0001") return "Jamais"
      return date
    },
    boolFormat (bool) {
      if (bool) {
        return "<i class=\"icon-checkmark\"></i>"
      } else {
        return "<i class=\"icon-cross\"></i>"
      }
    },
    upperFirstLetter (text) {
      if (text.length < 2) {
        return ""
      }
      return text[0].toUpperCase() + text.substr(1);
    },
    fullDateFormat (value) {
      if(value === null) return
      return "Le " + moment(value).format('DD/MM/YYYY') + " à " + moment(value).format('HH:mm:ss')
    },
    isEmpty(string) {
      if(string !== "" && string != null) return string
      return "Non renseigné"
    },
    timeElapsed(date) {
      let start = new Date(date)
      let now = new Date()
      let elapsedMonth = ((now.getFullYear() - start.getFullYear()) * 12) + (now.getMonth() - start.getMonth())
      return Math.floor(elapsedMonth / 12) + " ans et " + (elapsedMonth - Math.floor(elapsedMonth / 12) * 12) + " mois"
    },
    initTheme () {
      Vue.http.get('me/theme')
          .then(r => {
            localStorage.setItem('theme', JSON.stringify(r.body))
            theme.init()
          })
          .catch(() => {
            localStorage.setItem('theme', JSON.stringify(theme.defaultTheme()))
            theme.init()
          })
    }
  }
})

keycloak.init({ onLoad: 'check-sso', checkLoginIframe: false }).then(function (authenticated) {
  if (!authenticated) {
    keycloak.login({ redirectUri: location.origin + '/' })
    return
  }

  storeKeycloakUser()

  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}).catch(function () {
  window.location.href = process.env.OUPS_URL
})



// WEBPACK FOOTER //
// ./src/main.js